import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

const PLAYERS = [
  { name: "Tiger", idx: [0, 3, 6] },
  { name: "Lion", idx: [1, 4, 7] },
  { name: "Dragon", idx: [2, 5, 8] },
];

/**
 * Teenpatti Test (teen9) card overlay — reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle (toggle) + .casino-video-cards-container
 *     > 3 × div > .dealer-name.w-100.mb-1 (Tiger / Lion / Dragon) + 3 × span > img
 * Card order (reference): Tiger = cards[0,3,6], Lion = [1,4,7], Dragon = [2,5,8]; "1" = not dealt (back).
 * Hidden (.hide-cards) while cards[0] is "1" or after the shuffle toggle.
 */
export default function Teen9CardsOverlay({ cardString }) {
  const [showCards, setShowCards] = useState(true);
  if (cardString == null) return null;
  const cards = String(cardString).split(",").map((c) => c.trim());
  const hide = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hide ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {PLAYERS.map((p, k) => (
          <React.Fragment key={p.name}>
            {k > 0 && " "}
            <div>
              <div className="dealer-name w-100 mb-1">{p.name}</div>{" "}
              {p.idx.map((i, n) => (
                <React.Fragment key={i}>
                  {n > 0 && " "}
                  <span>
                    <CardImg src={getCardImage(cards[i])} />
                  </span>
                </React.Fragment>
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
